/**
 * Check if array of active contains data past 4th week
 * @param data array of active history
 * @returns {boolean}
 */
export function hasMoreActiveHistory(data) {
  return data?.slice(4)?.findIndex(({ weekly_progress: { percentage } }) => percentage > 0) !== -1
}
